// Card markup for the insights hub and archive, shared by the browser
// (js/insights-hub.js, js/insights-archive.js) and the build, which
// pre-renders the cards into insights.html / insights-archive.html
// (scripts/build-i18n.js loads this file in a sandbox).
(function (root) {
  var UI = {
    en: {
      locale: "en-GB",
      readMore: "Read more →",
      hubUnavailable: "Insights unavailable for the moment.",
      archiveUnavailable: "Archive unavailable for the moment.",
      types: {},
    },
    fr: {
      locale: "fr-FR",
      readMore: "Lire la suite →",
      hubUnavailable: "Les insights sont momentanément indisponibles.",
      archiveUnavailable: "Les archives sont momentanément indisponibles.",
      types: {
        insight: "Analyse",
        webinar: "Webinaire",
        product: "Produit",
        "case-study": "Étude de cas",
      },
    },
    de: {
      locale: "de-DE",
      readMore: "Weiterlesen →",
      hubUnavailable: "Insights sind derzeit nicht verfügbar.",
      archiveUnavailable: "Das Archiv ist derzeit nicht verfügbar.",
      types: {
        insight: "Analyse",
        webinar: "Webinar",
        product: "Produkt",
        "case-study": "Fallstudie",
      },
    },
  };

  function langOf(lang) {
    return UI[lang] ? lang : "en";
  }

  function pick(article, field, lang) {
    var t = article.i18n && article.i18n[lang];
    return t && t[field] !== undefined ? t[field] : article[field];
  }

  function targetAttr(article) {
    return article.target
      ? ' target="' + (article.target === true ? "_blank" : article.target) + '" rel="noopener"'
      : "";
  }

  // Hub: every featured article first, then the rest, three cards in all.
  function hubSelection(articles) {
    var featured = articles.filter(function (a) { return a.featured; });
    var rest = articles.filter(function (a) { return !a.featured; });
    return featured.concat(rest).slice(0, 3);
  }

  // Archive: newest first.
  function archiveSelection(articles) {
    return articles.slice().sort(function (a, b) {
      var at = a.date ? Date.parse(a.date + "T00:00:00") : 0;
      var bt = b.date ? Date.parse(b.date + "T00:00:00") : 0;
      return bt - at;
    });
  }

  function formatDate(value, lang) {
    if (!value) return "";
    var p = value.split("-");
    if (p.length !== 3) return value;
    // dd/mm/yyyy (en-GB, fr) or dd.mm.yyyy (de), without relying on the
    // runtime's locale data so the build and the browser agree.
    return lang === "de" ? p[2] + "." + p[1] + "." + p[0] : p[2] + "/" + p[1] + "/" + p[0];
  }

  // English keeps the lowercase slug (CSS capitalizes it); FR/DE labels are
  // already cased, so the CSS capitalize is switched off for them.
  function typeLabel(type, lang) {
    var label = UI[lang].types[type];
    return label
      ? '<span style="text-transform: none">' + label + "</span>"
      : "<span>" + type.replace(/-/g, " ") + "</span>";
  }

  // `cls` adds classes to each card (the browser passes "scroll-reveal").
  function hubCards(articles, lang, href, cls) {
    lang = langOf(lang);
    return hubSelection(articles)
      .map(function (a) {
        return (
          '<article class="insights-card' + (cls ? " " + cls : "") + '">' +
          '<span class="insights-eyebrow">' + (pick(a, "eyebrow", lang) || "") + "</span>" +
          '<h3 class="insights-module-title">' + pick(a, "title", lang) + "</h3>" +
          "<p>" + (pick(a, "text", lang) || "") + "</p>" +
          '<a class="insights-link" href="' + href(a.link) + '"' + targetAttr(a) + ">" +
          (pick(a, "linkLabel", lang) || UI[lang].readMore) + "</a></article>"
        );
      })
      .join("");
  }

  function archiveCards(articles, lang, href, cls) {
    lang = langOf(lang);
    return archiveSelection(articles)
      .map(function (a) {
        var meta = [];
        if (a.type) meta.push(typeLabel(a.type, lang));
        if (a.date) meta.push("<span>" + formatDate(a.date, lang) + "</span>");
        var metaHtml = meta.length
          ? '<div class="insights-archive-meta">' + meta.join('<span class="insights-archive-sep">/</span>') + "</div>"
          : "";
        return (
          '<article class="insights-card insights-archive-card' + (cls ? " " + cls : "") + '">' +
          '<div class="insights-archive-card-head"><span class="insights-eyebrow">' + (pick(a, "eyebrow", lang) || "") + "</span>" +
          metaHtml + '<h3 class="insights-module-title">' + pick(a, "title", lang) + "</h3></div>" +
          '<div class="insights-archive-card-body"><p>' + (pick(a, "text", lang) || "") + "</p>" +
          '<a class="insights-link" href="' + href(a.link) + '"' + targetAttr(a) + ">" +
          (pick(a, "linkLabel", lang) || UI[lang].readMore) + "</a></div></article>"
        );
      })
      .join("");
  }

  function unavailable(kind, lang) {
    lang = langOf(lang);
    return '<article class="insights-card"><p>' + UI[lang][kind === "hub" ? "hubUnavailable" : "archiveUnavailable"] + "</p></article>";
  }

  root.ForsytInsightsCards = {
    hubCards: hubCards,
    archiveCards: archiveCards,
    unavailable: unavailable,
  };
})(typeof window !== "undefined" ? window : globalThis);
